import { render, staticRenderFns } from "./CardProductbig.vue?vue&type=template&id=48dbe764&"
import script from "./CardProductbig.vue?vue&type=script&lang=js&"
export * from "./CardProductbig.vue?vue&type=script&lang=js&"
import style0 from "./CardProductbig.vue?vue&type=style&index=0&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Fcard-product&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports